module.exports = __webpack_public_path__ + "static/media/monit.92c44465.avif";